import React from "react";

const JobBoardComponent = ({
  job: {
    company,
    logo,
    isNew,
    featured,
    position,
    role,
    level,
    postedAt,
    contract,
    location,
    languages,
    tools,
  },
  handleTagClick,
}) => {
  const tags = [role, level].filter(Boolean);
  if (tools) {
    tags.push(...tools);
  }
  if (languages) {
    tags.push(...languages);
  }

  return (
    <div className="group relative bg-white border border-gray-100 p-8 md:p-10 transition-all duration-300 hover:shadow-2xl hover:border-blue-100 flex flex-col md:flex-row justify-between items-start md:items-center gap-8 w-full">
      {/* Optional decorative line */}
      <div className="absolute top-0 left-0 w-0 h-1 bg-blue-900 transition-all duration-500 group-hover:w-full" />
      
      <div className="flex flex-col md:flex-row gap-8 items-start md:items-center w-full md:w-auto">
        <div className="w-16 h-16 md:w-20 md:h-20 shrink-0 bg-gray-50 flex items-center justify-center p-2 rounded-sm border border-gray-100">
          <img src={logo} alt={company} className="max-w-full max-h-full object-contain" />
        </div>
        
        <div className="flex flex-col gap-2">
          <div className="flex flex-wrap items-center gap-3 mb-1">
            <span className="text-sm tracking-widest font-semibold text-blue-900 uppercase">{company}</span>
            {isNew && (
              <span className="text-xs bg-blue-50 text-blue-900 font-semibold px-3 py-1 rounded-sm uppercase tracking-wider">
                New
              </span>
            )}
            {featured && (
              <span className="text-xs border border-blue-900 text-blue-900 font-semibold px-3 py-1 rounded-sm uppercase tracking-wider">
                Featured
              </span>
            )}
          </div>
          
          <h2 className="text-2xl md:text-3xl font-light text-[#1a1a1a] tracking-wide mb-2 group-hover:text-blue-900 transition-colors">
            {position}
          </h2>
          
          <div className="flex flex-wrap items-center gap-4 text-sm text-gray-500 font-light tracking-wide uppercase">
            {postedAt && <span>{postedAt}</span>}
            {postedAt && <span className="w-1 h-1 bg-gray-300 rounded-full" />}
            {contract && <span>{contract}</span>}
            {contract && <span className="w-1 h-1 bg-gray-300 rounded-full" />}
            {location && <span>{location}</span>}
          </div>
        </div>
      </div>

      <div className="flex flex-col items-start md:items-end gap-6 w-full md:w-auto mt-4 md:mt-0 pt-6 md:pt-0 border-t border-gray-100 md:border-t-0">
        <div className="flex flex-wrap gap-2 justify-start md:justify-end">
          {tags.map((tag, index) => (
            tag ? (
              <button
                key={index}
                onClick={() => handleTagClick(tag)}
                className="text-xs tracking-widest bg-white border border-gray-200 text-gray-600 hover:border-blue-900 hover:text-blue-900 font-semibold py-1.5 px-4 transition-colors uppercase rounded-sm"
              >
                {tag}
              </button>
            ) : null
          ))}
        </div>
        
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSfXp6T7RRRBNiXfDy926LUaJKa3X-1x61_fxlTG4I8jYxzQmQ/viewform?usp=header"
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center justify-center gap-2 bg-blue-900 text-white px-8 py-3 text-sm tracking-widest font-semibold hover:bg-black transition-colors w-full md:w-auto rounded-sm uppercase"
        >
          Apply Now
          <svg className="w-4 h-4 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" /></svg>
        </a>
      </div>
    </div>
  );
};

export default JobBoardComponent;
